import React from "react";
import { Segmented } from "antd5";

const SegmentedItem = ({ options, onChange, style, className, defaultValue, value, disabled, size }) => {
  return (
     <Segmented
      options={options}
      onChange={onChange}
      disabled={disabled}
      size={size}
      style={{
        ...style,
      }}
      className={`segmented-custom ${className || ""}`}
      defaultValue={defaultValue}
      value={value}
    />
  );
};

export default SegmentedItem;